import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const atLeastOne = (validator: ValidatorFn) => (
  group: FormGroup,
): ValidationErrors | null => {
  const hasAtLeastOne =
    group &&
    group.controls &&
    Object.keys(group.controls).some(k => !validator(group.controls[k]));

  return hasAtLeastOne ? null : { atLeastOne: true };
};

export const customValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.parent) {
    const type = control.parent.get('type').value;
    const number = control.parent.get('number').value;
    switch (type.description) {
      case 'DNI':
        if (!/^[\d]{8}$/.test(number)) {
          return { 'invalidDNI': true };
        }
        break;
      case 'CUIT':
        if (!/^[\d]{11}$/.test(number)) {
          return { 'invalidCUIT': true };
        }
        break;
      case 'CEDULA IDENTIDAD EXTR.':
        // No hay restricciones para este tipo de documento
        break;
      default:
        return { 'unknownType': true };
    }
  }

  return null;
};